// extracted by mini-css-extract-plugin
module.exports = {"copyrightText":"_3bbb60e"};